import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massRestoreAirlines } from "../../api/apiAirlines";
import parseError from "../../utils/parseError";

const useRestoreAllAirlines = () => {
    const queryClient = useQueryClient();

    const { mutate: restoreAllAirlinesAction, isPending } = useMutation({
        mutationFn: massRestoreAirlines,
        onSuccess: (res) => {
            const message = res?.message || "Airlines restored successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["airlines"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to restore airlines");
        },
    });

    return { restoreAllAirlines: restoreAllAirlinesAction, isPending };
};

export default useRestoreAllAirlines;
